"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Grip = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var helios_styles_1 = require("@carvana/helios-styles");
var styled_components_1 = __importDefault(require("styled-components"));
var directionMap = {
    horizontal: '0deg',
    vertical: '90deg'
};
var SVG = styled_components_1.default.svg(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  transform: rotate(", ");\n"], ["\n  transform: rotate(", ");\n"])), function (props) { return directionMap[props.direction]; });
var Grip = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 24 : _b, _c = _a.color, color = _c === void 0 ? helios_styles_1.icon.default : _c, _d = _a.direction, direction = _d === void 0 ? 'horizontal' : _d;
    return ((0, jsx_runtime_1.jsx)(SVG, __assign({ direction: direction, width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsx)("path", { fill: color, fillRule: "evenodd", d: "M3 9C3 7.89543 3.89543 7 5 7C6.10457 7 7 7.89543 7 9C7 10.1046 6.10457 11 5 11C3.89543 11 3 10.1046 3 9ZM10 9C10 7.89543 10.8954 7 12 7C13.1046 7 14 7.89543 14 9C14 10.1046 13.1046 11 12 11C10.8954 11 10 10.1046 10 9ZM17 9C17 7.89543 17.8954 7 19 7C20.1046 7 21 7.89543 21 9C21 10.1046 20.1046 11 19 11C17.8954 11 17 10.1046 17 9ZM3 15C3 13.8954 3.89543 13 5 13C6.10457 13 7 13.8954 7 15C7 16.1046 6.10457 17 5 17C3.89543 17 3 16.1046 3 15ZM10 15C10 13.8954 10.8954 13 12 13C13.1046 13 14 13.8954 14 15C14 16.1046 13.1046 17 12 17C10.8954 17 10 16.1046 10 15ZM17 15C17 13.8954 17.8954 13 19 13C20.1046 13 21 13.8954 21 15C21 16.1046 20.1046 17 19 17C17.8954 17 17 16.1046 17 15Z", clipRule: "evenodd" }) })));
};
exports.Grip = Grip;
var templateObject_1;
